import Territory from './Territory';
export default Territory;
